import { IImageAsset } from '../../modules/images/types'

export const CELL_WIDTH = 42
export const MAX_ANSWERS = 6

import {
  AnswerID,
  IQuestionModelState,
  IQuestionSchema,
  IQuestionViewProps,
  IResponseValidation,
  QuestionModelTypes,
  QuestionType,
  SubQuestionID
} from '../types'

export type ProgressiveMatrixAnswer = {
  id: AnswerID
  text: string
  oe: 'off' | 'optional' | 'mandatory'
  image?: IImageAsset
  na?: boolean
  fakeHidden?: boolean
  number?: number
  hidden?: boolean
  exclusive?: string[]
}

export type ProgressiveMatrixBatch = {
  id: SubQuestionID
  image?: IImageAsset
  text: string
  fakeHidden?: boolean
  hidden?: boolean
  number?: number
  answers: ProgressiveMatrixAnswer[]
}

export interface IProgressiveMatrixQuestionSchema extends IQuestionSchema {
  type: QuestionType.PROGRESSIVE_MATRIX
  expand_all_images?: true
  flow: 'rows' | 'columns'
  min_choices?: number
  max_choices?: number
  global_max_choices?: number
  global_min_choices?: number
  numbering?: boolean
  progressive_flow?: boolean
  split_mobile?: boolean
  split_pc?: boolean
  split?: boolean
  sticky_header?: boolean
  subtype: 'rb' | 'cb'
  matrix_batches: ProgressiveMatrixBatch[]
}

export interface ISplittedQuestionSchema extends IQuestionSchema {
  type: QuestionType.CHECKBOXES | QuestionType.RADIO_BUTTONS
  parentId?: AnswerID
  min_choices?: number
  max_choices?: number
  hidden?: boolean
  fakeHidden?: boolean
  answers: {
    id: AnswerID
    text: string
    oe: 'off' | 'optional' | 'mandatory'
    image?: IImageAsset
    na?: boolean
  }[]
}

export type ProgressiveMatrixSubmitResponse = {
  id: AnswerID
  c?: string
}[]

export type ProgressiveMatrixDragState = {
  state: boolean
  x: number
  y: number
  shift: number
}

export type ProgressiveMatrixResponseCell = {
  id: AnswerID
  branchId?: AnswerID
  selected: boolean
  enabled?: boolean
  disabled?: boolean
  error?: boolean
  oe?: 'off' | 'optional' | 'mandatory'
  text?: string
  comment?: string
  x?: number
  y?: number
  na?: boolean
}

export type ProgressiveMatrixResponseFrame = ProgressiveMatrixResponseCell[]

export type ProgressiveMatrixHovered = {
  x: number | null
  y: number | null
}

export type ProgressiveMatrixAnswerViewProps = {
  label?: string
  name?: string
  schema: IProgressiveMatrixQuestionSchema
  answer: ProgressiveMatrixResponseCell
  hovered: boolean
  centered?: boolean
  onChange: (checked: boolean) => void
  onNavigate: (col: number, row: number) => void
  error?: boolean
}

export type ProgressiveMatrixResponse = { data: ProgressiveMatrixResponseFrame[]; split: boolean }

export interface IProgressiveMatrixResponseValidation extends IResponseValidation {
  // valid: boolean
  invalidBatches?: number[]
  currentValid?: boolean
}

export interface IProgressiveMatrixQuestionModelTypes extends QuestionModelTypes {
  schema: IProgressiveMatrixQuestionSchema
  response: ProgressiveMatrixResponse
  responseValidation: IProgressiveMatrixResponseValidation
  submitResponse: ProgressiveMatrixSubmitResponse
}

export interface IProgressiveMatrixQuestionModelState
  extends IQuestionModelState<IProgressiveMatrixQuestionModelTypes> {}

export interface IProgressiveMatrixQuestionViewProps extends IQuestionViewProps<IProgressiveMatrixQuestionModelTypes> {
  onUpdateFrameResponse?: (response: ProgressiveMatrixResponse, lastFrame: number) => void
  // counts the refused advances; each one brings the row under validation out from under the pinned band
  validationAttempt?: number
}

export type SplittedAnswers = {
  id: AnswerID
  text: string
  image?: IImageAsset
  oe: 'off' | 'optional' | 'mandatory'
  na?: boolean
  exclusive?: string[]
}[]

export const EMPTY_RESPONSE: ProgressiveMatrixResponseFrame[] = []
export const EMPTY_SUBMIT_RESPONSE: ProgressiveMatrixSubmitResponse = []

// status - remove
// matrix_batches.fixedPosition - remove
// matrix_batches.type - remove
// matrix_batches.answers.fixedPosition - remove
// matrix_batches.answers.type - remove
